import { z } from 'zod';

const couponSchema = z
  .object({
    duration: z.string(),
    percent_off: z.number(),
  })
  .nullable()
  .optional();

const upfrontAmountSchema = z.object({
  original_amount: z.number(),
  payable_amount: z.number(),
  currency: z.string(),
});

const paymentPlanSchema = z.object({
  type: z.string(),
  recurring_interval: z.string().optional(),
  recurring_interval_count: z.number().optional(),
  upfront_amount: upfrontAmountSchema,
});

export const dynamicPriceSchema = z
  .object({
    results: z.array(
      z.object({
        coupon: couponSchema,
        payment_plans_v2: z.array(paymentPlanSchema),
        degree_application_amount: z.number(),
        price: z.object({
          currency: z.string(),
        }),
      })
    ),
  })
  .transform((data) => {
    const result = data.results[0];
    const monthlyPlan = result.payment_plans_v2.find(
      (plan) => plan.type === 'recurring' && plan.recurring_interval_count === 1
    );

    if (!monthlyPlan) {
      throw new Error('No monthly recurring payment plan found');
    }

    return {
      monthlyOriginalAmount: monthlyPlan.upfront_amount.original_amount,
      monthlyPayableAmount: monthlyPlan.upfront_amount.payable_amount,
      enrollmentFee: result.degree_application_amount,
      currency: result.price.currency,
      isForeverCoupon: result.coupon?.duration === 'forever',
      percentOff: result.coupon?.percent_off ?? null,
    };
  });

export type DynamicPrice = z.infer<typeof dynamicPriceSchema>;
